<template>

<core-filter-advanced-group title="Tag Families" :count="count" :label="label">

	<p v-if="!isOwner && tags.length">The following tag families have been made public by the owner of this collection.</p>
	
	<p v-if="!tags.length">There are no tag families available for this collection.</p>

	<core-filter-input-toggles :colour="tag.colour" :text="tag.text" :subtext="tag.subtext" :icons="toggle.icons" :labels="toggle.labels" :values="toggle.values" :posneg="tag.id" :filter="value('tagfamilies')" v-for="tag in tags" :key="tag.id" />

</core-filter-advanced-group>

</template>

<script>

import Group from 'core/mixin/filter/Group.js'

export default {

	mixins: [Group],

	data: function() {

		return {

			fields: ['tagfamilies'],

			toggle: {

				icons: [false, false, 'arrows-alt-h', false],
				values: [3, 1, 0, 2],
				labels: ['Must', 'Include', '', 'Exclude']

			}

		}

	},

	computed: {

		tags: function() {

			var tags = []

			this.$_.each(this.$store.getters['data/tagFamilies/list'], function(tag) {

				tags.push({
					id: tag.id,
					text: tag.name,
					colour: tag.colour
				})

			}.bind(this))

			return tags

		}

	}

}

</script>